import type { ReactNode } from "react";
import { cn } from "@client/lib/cn";

interface BadgeProps {
  children: ReactNode;
  className?: string;
}

/** Pill label: mono, uppercase, accent hairline (design.xml "Badges/Pills"). */
export function Badge({ children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 rounded-full border border-border-accent bg-accent-soft px-3 py-1 font-mono text-xs tracking-widest text-foreground uppercase",
        className,
      )}
    >
      {children}
    </span>
  );
}
